
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Helper functions to check environment
export const isProduction = () => {
  const hostname = window.location.hostname;
  return hostname === 'dably-frontend-prod.onrender.com';
};

export const isStaging = () => {
  const hostname = window.location.hostname;
  return hostname === 'dably-frontend-staging.onrender.com';
};

export const isDevelopment = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname.includes('localhost');
};
